/**
 * Depth helpers (owner: env-builder). World objects sort by feet Y: depth = Depth.WORLD_BASE + feetY.
 */
import { Depth } from '@/core/config';

export interface DepthSortable { y: number; setDepth(value: number): unknown }

export function depthForFeet(feetY: number): number {
  return Depth.WORLD_BASE + Math.round(feetY);
}

/** Applies feet-based depth to any positioned object. `feetOffset` shifts the sort line (e.g. +16 for a centred-origin prop). */
export function applyWorldDepth(obj: DepthSortable, feetOffset = 0): number {
  const d = depthForFeet(obj.y + feetOffset);
  obj.setDepth(d);
  return d;
}

/** Sorts a list of objects in-place by feet Y for deterministic batching. */
export function sortByFeet<T extends { y: number }>(list: T[], offsets?: Map<T, number>): T[] {
  return list.sort((a, b) => (a.y + (offsets?.get(a) ?? 0)) - (b.y + (offsets?.get(b) ?? 0)));
}
